<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <div
      class="recorder"
      :class="{'active': isPilotRecording}"
    >
      <button
        role="button"
        class="recorder-button"
        :class="{'active': isPilotRecording}"
        @click.prevent="onRecorderButtonClicked"
      >
        {{ $t(recorderButtonText) + remainTimeStr }}
      </button>
      <div
        v-if="remainTimeWarningActive"
        class="remainTimeWarning"
      >
        {{ $t('pilotRecorderRemainTimeWarning') }}
      </div>
    </div>
    <audio
      id="myVideo"
      playsinline
      class="video-js vjs-default-skin display-none"
    />
    <!-- <div v-show="!isPilotPlaying">
    <video
      id="myVideo"
      playsinline
      class="video-js vjs-default-skin"></video>
  </div> -->
    <div
      v-if="recorderPopupActive"
      class="recorder-popup"
    >
      <div class="recorder-popup-inner">
        <div class="recorder-popup-title">
          {{ $t(recorderPopupTitle) }}
        </div>
        <div
          class="recorder-popup-text"
          :class="{'is-notice': !deviceInitialized}"
          v-html="$t(recorderPopupText)"
        />
        <button
          role="button"
          class="close-window-button"
          @click="closeRecorderPopup"
        >
          {{ $t('pilotRecorderPopupButtonOK') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
// import { mapGetters } from 'vuex'
import 'video.js/dist/video-js.min.css'
import 'videojs-wavesurfer/dist/css/videojs.wavesurfer.css'
import 'videojs-record/dist/css/videojs.record.css'
import videojs from 'video.js'
import RecordRTC from 'recordrtc' // eslint-disable-line
import WaveSurfer from 'wavesurfer.js'
import MicrophonePlugin from 'wavesurfer.js/dist/plugin/wavesurfer.microphone.js'
// register videojs-wavesurfer plugin
import Wavesurfer from 'videojs-wavesurfer/dist/videojs.wavesurfer.js' // eslint-disable-line
import Record from 'videojs-record/dist/videojs.record.js' // eslint-disable-line
// import LamejsEngine from 'videojs-record/dist/plugins/videojs.record.lamejs.js' // eslint-disable-line
import { pilotSVC, userSVC } from '@/plugins/axios/services'
import { fetchPilot, addPilotChapter } from '@/plugins/firebase'

export default {
  name: 'PilotRecorder',
  data () {
    return {
      recorderPopupActive: false,
      recorderPopupTitle: 'pilotRecorderPopupTitleError',
      recorderPopupText: 'pilotRecorderPopupTextRelogin',
      recordPermission: false,
      naviCollection: [],
      history: [],
      currentBuildingId: '',
      currentPanoramaId: '',
      currentPanoramaAnimation: false,
      panoramaChanged: false,
      timeoutId: null,
      intervalId: null,
      checkPermissionTimeout: null,
      isInitialized: false,
      isUploading: false,
      isUploadFailed: false,
      isUploadComplete: false,
      deviceInitialized: false,
      shouldCloseWindow: false,
      remainTimeStr: ' (10:00)',
      remainTimeWarningActive: false,
      videoStartTime: 0,
      videoRecorder: null,
      videoRecorderOptions: {
        // video.js options
        controls: true,
        bigPlayButton: false,
        loop: false,
        fluid: false,
        width: 320,
        height: 240,
        plugins: {
          wavesurfer: {
            backend: 'WebAudio',
            waveColor: '#36393b',
            progressColor: 'black',
            debug: true,
            cursorWidth: 1,
            hideScrollbar: true,
            plugins: [
              // enable microphone plugin
              WaveSurfer.microphone.create({
                bufferSize: 4096,
                numberOfInputChannels: 1,
                numberOfOutputChannels: 1,
                constraints: {
                  video: false,
                  audio: true
                }
              })
            ]
          },
          // videojs-record plugin options
          record: {
            image: false,
            audio: true,
            // video: true,
            video: false,
            maxLength: 360000,
            debug: true
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'currentBuilding',
      'currentPanorama',
      'isFloorplanActive',
      'isLocationActive',
      'isMarkerInfoActive',
      'isPopupActive',
      'isPanoramasListActive',
      'isShareActive',
      'isPilotRecording',
      'isPilotPlaying',
      'markerInfoData',
      'popupMarker',
      'krpanoEl',
      'krpanoLookAtH',
      'krpanoLookAtV',
      'krpanoFov'
    ]),
    ...mapGetters('auth', [
      'sessionLoginLoading'
    ]),
    pilotId () {
      return this.$route.query.recordPilot
    },
    recorderButtonText () {
      if (this.isUploadFailed) {
        return 'pilotRecorderUploadFailed'
      } else if (this.isUploadComplete) {
        return 'pilotRecorderPopupTitleComplete'
      } else if (!this.isPilotRecording) {
        return 'pilotRecorderStart'
      } else if (this.isUploading) {
        return 'pilotRecorderUploading'
      } else {
        return 'pilotRecorderStop'
      }
    }
  },
  watch: {
    currentPanorama: {
      handler () {
        if (this.isPilotRecording) {
          this.panoramaChanged = true
        }
      }
    }
  },
  beforeCreate () {
    WaveSurfer.microphone = MicrophonePlugin
  },
  mounted () {
    if (!this.isInitialized) {
      this.checkRecordPermission()
      this.videoRecorder = videojs('myVideo', this.videoRecorderOptions)
      this.videoRecorder.on('progressRecord', () => {
        const countdown = 600 - this.videoRecorder.record().getDuration()
        const countdownM = Math.floor(countdown / 60)
        const countdownS = Math.floor(countdown % 60)
        this.remainTimeStr = ` (${countdownM}:${countdownS < 10 ? `0${countdownS}` : countdownS})`
        if (countdown < 60 && !this.remainTimeWarningActive) {
          this.remainTimeWarningActive = true
        }
        if (countdown < 0 && this.isPilotRecording) {
          this.remainTimeStr = ''
          this.stop()
        }
      })
      // for video
      // this.videoRecorder.record().getDevice()
      this.isInitialized = true
    }
  },
  beforeDestroy () {
    clearTimeout(this.checkPermissionTimeout)
  },
  methods: {
    ...mapActions([
      'startPilotRecorder',
      'stopPilotRecorder',
      'stopPilotPlayer',
      'closeFloorplan',
      'closePanoramasList',
      'stopAutoRotate'
    ]),
    onRecorderButtonClicked () {
      if (!this.recordPermission || !this.deviceInitialized) {
        return
      }
      if (!this.isPilotRecording) {
        this.stopAutoRotate()
        this.start()
      } else {
        this.stop()
      }
    },
    async checkRecordPermission () {
      if (this.sessionLoginLoading) {
        this.checkPermissionTimeout = setTimeout(() => {
          this.checkRecordPermission()
        }, 300)
        return
      }
      this.recordPermission = false
      const ret = await userSVC.getUserProfile()
      if (ret.success) {
        const userId = ret.data.objectId
        const pilot = await fetchPilot(this.pilotId)
        if (pilot && pilot.ownerId === userId) {
          this.recordPermission = true
        }
      }
      if (!this.recordPermission) {
        this.recorderPopupTitle = 'pilotRecorderPopupTitleError'
        this.recorderPopupText = 'pilotRecorderPopupTextRelogin'
        this.shouldCloseWindow = true
        this.recorderPopupActive = true
        return
      }
      // for audio
      this.recorderPopupTitle = 'pilotRecorderPopupTitleNotice'
      this.recorderPopupText = 'pilotRecorderPopupTextNotice'
      this.shouldCloseWindow = false
      this.recorderPopupActive = true
    },
    start () {
      if (this.isPilotPlaying) {
        this.stopPilotPlayer()
      }
      this.closeFloorplan()
      this.closePanoramasList()
      this.startPilotRecorder()
      this.timeoutId = setTimeout(() => {
        this.startVideoRecorder()
      }, 50)
      this.currentBuildingId = this.currentBuilding.objectId
      this.currentPanoramaId = this.currentPanorama.objectId
      this.currentPanoramaAnimation = this.currentPanorama.isFromMarkerPoint || false
      this.videoStartTime = 0
      this.history = []
      this.panoramaChanged = false
      this.recordHistory()
      this.intervalId = setInterval(this.recordHistory, 500)
    },
    cut (flush = false) {
      const nextHistoryData = flush ? null : this.history.pop()
      const videoCurrentDuration = this.videoRecorder.record().getDuration()
      const data = {
        buildingId: this.currentBuildingId,
        panoramaId: this.currentPanoramaId,
        pilotId: this.pilotId,
        startTime: Math.round(this.videoStartTime * 100) / 100,
        duration: Math.floor((videoCurrentDuration - this.videoStartTime) * 100) / 100,
        naviData: {
          animation: this.currentPanoramaAnimation,
          history: this.history
        }
      }
      if (data.naviData.history.length > 2) {
        // skip short data which may be generated when changing building
        this.naviCollection.push(data)
      }
      this.currentBuildingId = this.currentBuilding.objectId
      this.currentPanoramaId = this.currentPanorama.objectId
      this.currentPanoramaAnimation = this.currentPanorama.isFromMarkerPoint || false
      this.videoStartTime = videoCurrentDuration
      this.history = flush ? [] : [nextHistoryData]
    },
    stop () {
      if (!this.isUploading) {
        this.isUploading = true
      } else {
        return
      }
      clearInterval(this.intervalId)
      this.videoRecorder.one('finishRecord', async () => {
        this.cut(true)
        const url = await pilotSVC.uploadPilotVideo(this.videoRecorder.recordedData, this.pilotId, 'audio')
        this.videoRecorder.record().reset()
        if (!url) {
          this.isUploadFailed = true
          this.recorderPopupTitle = 'pilotRecorderPopupTitleError'
          this.recorderPopupText = 'pilotRecorderPopupTextRelogin'
          this.shouldCloseWindow = true
          this.recorderPopupActive = true
          return
        }
        this.naviCollection.forEach(naviCollectionData => {
          naviCollectionData.videoUrl = url
        })
        await addPilotChapter(this.naviCollection, this.pilotId, this.$route.query.pilotChapter || '')
        this.naviCollection = []
        this.stopPilotRecorder()
        this.isUploading = false
        this.isUploadComplete = true
        this.recorderPopupTitle = 'pilotRecorderPopupTitleComplete'
        this.recorderPopupText = 'pilotRecorderPopupTextComplete'
        this.shouldCloseWindow = true
        this.recorderPopupActive = true
      })
      this.videoRecorder.record().stop()
    },
    startVideoRecorder () {
      if (!this.videoRecorder.record().isRecording()) {
        this.videoRecorder.record().start()
        //  try again to make sure it starts successfully
        clearTimeout(this.timeoutId)
        this.timeoutId = setTimeout(() => {
          this.startVideoRecorder()
        }, 50)
      }
    },
    recordHistory () {
      this.history.push({
        floorplan: this.isFloorplanActive,
        location: this.isLocationActive,
        share: this.isShareActive,
        panoramaList: this.isPanoramasListActive,
        markerInfo: this.isMarkerInfoActive,
        markerId: this.markerInfoData.objectId,
        popup: this.isPopupActive,
        popupId: this.popupMarker.objectId,
        cameraH: this.krpanoLookAtH,
        cameraV: this.krpanoLookAtV,
        cameraFov: this.krpanoFov
      })
      if (this.panoramaChanged) {
        this.panoramaChanged = false
        this.cut()
      }
    },
    closeRecorderPopup () {
      if (this.shouldCloseWindow) {
        window.close()
      }
      // for audio
      if (!this.deviceInitialized) {
        this.videoRecorder.one('deviceReady', () => {
          this.deviceInitialized = true
        })
        this.videoRecorder.one('deviceError', () => {
          this.recorderPopupTitle = 'pilotRecorderPopupTitleError'
          this.recorderPopupText = 'pilotRecorderPopupTextError'
          this.shouldCloseWindow = true
          this.recorderPopupActive = true
        })
        this.videoRecorder.record().getDevice()
      }
      this.recorderPopupActive = false
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/addon/main';

.recorder {
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-style: solid;
  border-width: 3px;
  border-color: #149319;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  pointer-events: none;
  z-index: $pilot-recorder-z;

  &.active {
    border-color: #E12323;
  }

  .recorder-button {
    width: 250px;
    height: 40px;
    font-size: 18px;
    line-height: 20px;
    color: $white;
    background-color: #149319;
    cursor: pointer;
    pointer-events: auto;

    &.active {
      background-color: #E12323;
    }
  }

  .remainTimeWarning {
    margin-top: 10px;
    padding: 0 10px;
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    color: $white;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 5px;
  }
}

.recorder-popup {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  z-index: 20;

  .recorder-popup-inner {
    padding: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.7);

    .recorder-popup-title {
      width: 250px;
      font-weight: bold;
      font-size: 20px;
      line-height: 23px;
      text-align: center;
      color: $white;
    }

    .recorder-popup-text {
      margin-top: 25px;
      min-width: 250px;
      font-size: 16px;
      line-height: 20px;
      text-align: center;
      color: $white;

      &.is-notice {
        text-align: left;
      }
    }

    .close-window-button {
      margin-top: 25px;
      width: 100px;
      height: 40px;
      font-weight: bold;
      font-size: 16px;
      line-height: 20px;
      color: $black;
      background-color: #F8CD55;
      border-radius: 5px;
      cursor: pointer;
    }
  }
}

.display-none {
  display: none;
}
</style>
